// import CustomProductsPage from './Pages/CustomProductOverview/CustomProductOverviewPage';
import { isComponentFor } from 'Shared/resolve-component';
export default (currentPage) => {
    return isComponentFor(currentPage.componentName, "Avensia.Shop.Features.CustomProducts.Pages.CustomProductOverview.CustomProductOverviewPageViewModel");
};
export function componentNameIsCustomProductsPage(componentName) {
    return isComponentFor(componentName, "Avensia.Shop.Features.CustomProducts.Pages.CustomProductOverview.CustomProductOverviewPageViewModel");
}
